<template>
  <div class="process">
    <div class="process-img">
      <div class="step" >
      <div  :class="step>=1 ?'active':''" :style="[{borderRadius:(step>1?'3px 0px 0px 3px':'')},{background:(step>1?'#F09897':'')}]" ><span class="active1" :style="[{background:(step>1?'#F09897':'')}]" >1</span></div>
       <div :class="step>=2?'active':''" :style="[{borderRadius:(step===2?'3px 0px 0px 3px':'')},{borderRadius:(step===3?'0px 0px 0px 0px':'')},{background:(step===3?'#F09897':'')}]"><span class="active1" :class="step>=2?'active':''" :style="[{background:(step>2?'#F09897':'')}]">2</span></div>
       <div :class="step>=3?'active':''" :style="[{borderRadius:(step===3?'0px 3px 3px 0px':'')}]"><span class="active1" :class="step>=3?'active':''">3</span></div>
      </div>
      <!-- <img v-if="step===1" src="/static/img/process_1.png" />
      <img v-else-if="step===2" src="/static/img/process_2.png" />
      <img v-else src="/static/img/process_3.png" /> -->
    </div>
    <div class="process-title">
      <span v-for="(item, index) in titleArr" :key="index" >
       <span :class="{choose:index===step-1}" :style="[{color:(step-1>index?'#F09897':'')}]"  > {{item}}</span>
      </span>
    </div>
  </div>
</template>
<script>
/**
 *
 */
export default {
  name: '',
  props: {
    step: {
      type: Number,
      default: 1
    },
    titleArr: {
      required: true,
      type: Array
    }
  }
}
</script>
<style lang="less" scoped>
.process{
  box-sizing: border-box;
  width:480px;
  height:auto;

  // margin: 0px auto;
  .process-img{

.step{
  height: 5px;
background: #D8D8D8;
border-radius: 3px;
display: flex;
    justify-content: space-between;
div{
  text-align: center;
 width: 160px;
        height: 5px;
        border-radius: 3px;
            display: flex;
    justify-content: center;
    align-items: center;
  span{
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  background: #d8d8d8;
    border-radius: 50%;

    position: relative;

}

 &.active{
      background: #E23130;
      span{
         background: #E23130;
      }

    }
}
  }
  }

  span{
    display: inline-block;

  }
  img{
    width: 534px;
    height: 37px;
  }
}
.process-title{
  position: relative;
  margin-top: 12px;
  span{
    color: #929292;
    display: inline-block;
   width: 160px;
   font-size: 12px;

  }
}
.choose{
 height: 16px;
font-size: 12px;
font-family: MicrosoftYaHei;
color: #E23130 !important;
line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/common/process.vue